import axios from 'axios';

const useProxy = () => {
  return (url, params, headers) => {
    const parsedURL = new URL(url);

    new URLSearchParams(params).forEach((value, key) =>
      parsedURL.searchParams.set(key, value)
    );

    return axios.post('proxy/', { url: parsedURL }, headers);
  };
};

export default useProxy;
